<template>
  <el-dialog
    v-if="isVisible"
    v-model="isVisible"
    class="order-test"
    title=""
    :show-close="false"
    :width="width"
    modal-class="order-test-dialog"
    @close="$emit('close')"
  >
    <template #header>
      <div class="flex justify-between items-center px-6 py-4 bg-[#004879] text-white rounded-t-[10px]">
        <span class="font-semibold text-[20px] leading-normal">{{ title }}</span>
        <button class="bg-transparent border-none p-0 cursor-pointer w-7 h-7" @click="$emit('close')">
          <img src="@/assets/MyPatient/close.svg" alt="Close" class="w-full h-full" />
        </button>
      </div>
    </template>
    <div class="py-6 px-9 content">
      <slot></slot>
      <slot name="footer" v-if="showFooter">
        <div class="flex flex-row-reverse mt-6">
          <slot name="buttons">
            <LoginButton @click="isPromoPanel ? $emit('done') : $emit('close')" type="primary" class="w-36">
              {{ isPromoPanel ? 'Done' : 'Close'}}
            </LoginButton>
          </slot>
        </div>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
import LoginButton from '@/views/login/components/LoginButton.vue';
export default {
  emits: ["close","done"],
  components: {
    LoginButton
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 573
    },
    isShowDialog: {
      type: Boolean,
      default: false
    },
    isPromoPanel: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    }
  },

  mounted() {
    this.isVisible = this.isShowDialog;
  }
}
</script>

<style>
.order-test-dialog .el-dialog {
  border-radius: 10px;
  height: auto !important;
  --el-dialog-padding-primary: 0px !important;
}
.order-test-dialog .el-dialog__header {
  padding: 0;
  border-bottom: none;
}
.order-test-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.content {
  color: #161616;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.25px;
  word-break: normal;
}
.content :deep(.btn-primary),
.content :deep(.btn-primary:hover) {
  border-color: #004879 !important;
  background: #004879 !important;
}
</style>